import React from "react";
import {
  FormGroup,
  Label,
  Input,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from "reactstrap";
import style from "../Toolbar.module.scss";

const AdvancedSearch = ({ open, onSearch, advanced, onChange }) => {
  return open ? (
    <FormGroup className={style.advanced}>
      <DropDownFilterDateType value={advanced.type} onChange={onChange} />
      <div className={style.inputs}>
        <Input
          type="date"
          value={advanced.fromDate}
          placeholder="From"
          onChange={(e) => onChange("fromDate", e.target.value)}
          required
        />
        <div style={{ width: "15px" }} />
        <Input
          type="date"
          value={advanced.toDate}
          placeholder="To"
          onChange={(e) => onChange("toDate", e.target.value)}
        />
      </div>
      <Button
        type="button"
        color="primary"
        style={{
          height: "35px",
        }}
        onClick={() => onSearch()}
      >
        Search
      </Button>

      <Button
        type="button"
        color="primary"
        style={{
          marginLeft: "5px",
          height: "35px",
          whiteSpace: "nowrap",
        }}
        onClick={() => onChange("open", !open)}
      >
        Hide <i className="fa fa-caret-up"></i>
      </Button>
    </FormGroup>
  ) : null;
};

const DropDownFilterDateType = ({ value, onChange }) => (
  <UncontrolledDropdown>
    <DropdownToggle caret color="secondary" className={style.dropdown}>
      {value != "Process" ? "Settlement" : "Process"}
    </DropdownToggle>
    <DropdownMenu>
      <DropdownItem onClick={() => onChange("type", "Process")}>Process</DropdownItem>
      <DropdownItem onClick={() => onChange("type", "Settlement")}>Settlement</DropdownItem>
    </DropdownMenu>
  </UncontrolledDropdown>
);

export default AdvancedSearch;
